export default __webpack_public_path__ + "static/media/sp-sb-boy.f4d5d388.webp";